




























































import Vue from 'vue';
import { mapActions } from 'vuex';
import { Component } from 'vue-property-decorator';
import moment from 'moment';
import UpdateTemplateModal from './UpdateTemplateModal.vue';
import RemoveTemplateModal from './RemoveTemplateModal.vue';
import NotificationHook from './NotificationHook.vue';

@Component({
    filters: {
        formatDate: (value: string) => moment(value).format('LLL')
    },
    components: {
        UpdateTemplateModal,
        RemoveTemplateModal,
        NotificationHook
    },
    methods: mapActions('bh-notification-templates', { addNewTemplate: 'create' })
})
export default class TemplateManager extends Vue {
    addNewTemplate: any;

    search = '';
    dialogAddTemplate = false;
    dialogAddTemplateLoading = false;
    successMessage = false;
    error = {
        show: false,
        message: ''
    };
    headers = [
        {
            text: 'ID',
            align: 'start',
            sortable: true,
            value: 'id',
        },
        {
            text: 'Template Name',
            align: 'start',
            sortable: false,
            value: 'name'
        },
        {
            text: 'Message',
            align: 'start',
            sortable: false,
            value: 'message'
        },
        {
            text: 'Type',
            align: 'end',
            sortable: false,
            value: 'target_type'
        },
        {
            text: 'Status',
            align: 'start',
            sortable: false,
            value: 'status'
        },
        {
            text: 'Date Added',
            align: 'end',
            sortable: false,
            value: 'createdAt'
        },
        {
            text: 'Actions',
            align: 'end',
            value: 'data-table-expand'
        }
    ];
    form = {
        name: '',
        message: '',
        target_type: ''
    };
    query = { /*id: { $nin: [this.user.id] }*/ };
    pagination = {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: []
    };

    public get fetchQuery() {
        return Object.assign({}, {
            ...this.query,
            // ...this.extendedQuery,
            $populate: true
        }, {
            // ...this.searchQuery,
            $limit: this.pagination.itemsPerPage,
            $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
            ...this.sortingQuery
        });
    }

    public get dataQuery() {
        return {
            ...this.query,
            // ...this.extendedQuery,
            // ...this.searchDataQuery,
            $limit: this.pagination.itemsPerPage,
            $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
            ...this.sortingQuery
        };
    }

    public get sortingQuery() {
        if(this.pagination.sortBy.length !== 0) {
            const $sort: any = {};
            this.pagination.sortBy.map((item, index) => {
                switch(item) {
                    default:
                        $sort[item] = this.pagination.sortDesc[index] ? -1 : 1;
                }
                
            });
            return { $sort };
        }
        return null;
    }

    public onError(err: any) {
        this.error.show = true;
        this.error.message = err.message;
    }

    public async addNotificationTemplate() {
        try {
            this.dialogAddTemplateLoading = true;
            await this.addNewTemplate(this.form);
            this.form = {
                name: '',
                message: '',
                target_type: ''
            };
            this.successMessage = true;
            this.dialogAddTemplate = false;
        } catch(err) {
            this.error.show = true;
            this.error.message = (err as any).message;
        } finally {
            this.dialogAddTemplateLoading = false;
        }
    }
}
